export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-03.9311ed09.jpg";